import { createSelector } from 'reselect'

import { DELIVERY_OPTION } from '@cinch/oxd-containers/delivery-preference/src'

import { ProfileReducer } from './../reducers/domain'

const isAllLocationValuesSet = (data: ProfileReducer['data']) =>
  !!data &&
  ((!!data.longitude && !!data.latitude && !!data.location) || data.deliveryOption === DELIVERY_OPTION.DELIVERY)

const isAnyBudgetValuesSet = (data: ProfileReducer['data']) => !!data && !!data.budget

const isFirstNameSet = ({ profile }: { profile: ProfileReducer }) =>
  !!profile && !!profile.data && !!profile.data.firstName ? 0.075 : 0
const isLastNameSet = ({ profile }: { profile: ProfileReducer }) =>
  !!profile && !!profile.data && !!profile.data.lastName ? 0.075 : 0
const isPhoneSet = ({ profile }: { profile: ProfileReducer }) =>
  !!profile && !!profile.data && !!profile.data.phoneNumber ? 0.05 : 0
const isEmailSet = ({ profile }: { profile: ProfileReducer }) =>
  !!profile && !!profile.data && !!profile.data.email ? 0.3 : 0
const isLocationSet = ({ profile }: { profile: ProfileReducer }) => (isAllLocationValuesSet(profile.data) ? 0.2 : 0)
const isBudgetSet = ({ profile }: { profile: ProfileReducer }) => (isAnyBudgetValuesSet(profile.data) ? 0.3 : 0)

export default createSelector(
  isFirstNameSet,
  isLastNameSet,
  isPhoneSet,
  isEmailSet,
  isLocationSet,
  isBudgetSet,
  (...weights) => weights.reduce((total: number, weight: number) => total + weight, 0),
)
